import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteRecordRaw,
} from "vue-router";
import LoginView from "../login.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    component: LoginView,
  },
  {
    path: "/home",
    name: "home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/HomeView.vue"),
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "index",
        component: () => import("../views/IndexView.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/company",
        name: "company",
        component: () => import("../views/system/basic-data/company.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/dept",
        name: "dept",
        component: () => import("../views/system/basic-data/department.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/emp",
        name: "emp",
        component: () => import("../views/system/basic-data/emp.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/menu",
        name: "menu",
        component: () => import("../views/system/authority/menu.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/menuPort",
        name: "menuPort",
        component: () => import("../views/system/authority/menuPort.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/sys_role",
        name: "sys_role",
        component: () => import("../views/system/authority/role.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/sys_roleControl",
        name: "roleControl",
        component: () => import("../views/system/authority/roleControl.vue"),
        meta: { isBack: true, keepAlive: false },
      },
      {
        path: "/empDistribution",
        name: "empDistribution",
        component: () =>
          import("../views/system/authority/empDistribution.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/empControl",
        name: "empControl",
        component: () => import("../views/system/authority/empControl.vue"),
        meta: { isBack: true, keepAlive: true },
      },
      {
        path: "/documents",
        name: "documents",
        component: () => import("../views/system/flow/documents.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/sys_flow",
        name: "sys_flow",
        component: () => import("../views/system/flow/flow.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/jobCode",
        name: "jobCode",
        component: () => import("../views/system/flow/jobCode.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/sys_brand",
        name: "sys_brand",
        component: () => import("../views/system/sys-car/brand.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/sys_series",
        name: "sys_series",
        component: () => import("../views/system/sys-car/series.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/sys_model",
        name: "sys_model",
        component: () => import("../views/system/sys-car/model.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/controller",
        name: "set_controller",
        component: () => import("../views/system/set/controller.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/dic",
        name: "set_dic",
        component: () => import("../views/system/set/dic.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/validValue",
        name: "set_validValue",
        component: () => import("../views/system/set/validValue.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/form",
        name: "set_form",
        component: () => import("../views/system/set/form.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/set_apply",
        name: "set_apply",
        component: () => import("../views/system/set/apply.vue"),
        meta: { keepAlive: true },
      },
      // 基础数据——基础档案
      {
        path: "/company_user",
        name: "company_user",
        component: () =>
          import("../views/basic-data-user/records/company_user.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/dept_user",
        name: "dept_user",
        component: () =>
          import("../views/basic-data-user/records/department_user.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/emp_user",
        name: "emp_user",
        component: () =>
          import("../views/basic-data-user/records/emp_user.vue"),
        meta: { keepAlive: true },
      },
      // 基础数据——车辆管理
      {
        path: "/brand_user",
        name: "brand_user",
        component: () => import("../views/basic-data-user/car_user/brand.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/series_user",
        name: "series_user",
        component: () => import("../views/basic-data-user/car_user/series.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/model_user",
        name: "model_user",
        component: () => import("../views/basic-data-user/car_user/model.vue"),
        meta: { keepAlive: true },
      },
      // 基础数据——权限管理
      {
        path: "/role_user",
        name: "/role",
        component: () =>
          import("../views/basic-data-user/authority_user/role.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/roleControl_user",
        name: "/roleControl",
        component: () =>
          import("../views/basic-data-user/authority_user/roleControl.vue"),
        meta: { keepAlive: false },
      },
      {
        path: "/empControl_user",
        name: "/empControl_user",
        component: () =>
          import("../views/basic-data-user/authority_user/empControl.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/empDistribution_user",
        name: "/empDistribution_user",
        component: () =>
          import("../views/basic-data-user/authority_user/empDistribution.vue"),
        meta: { keepAlive: true },
      },
      //基础数据——流程维护
      {
        path: "/flow_user",
        name: "/flow",
        component: () => import("../views/basic-data-user/flow_user/flow.vue"),
        meta: { keepAlive: true },
      },
      // 基础数据——客户管理
      {
        path: "/client",
        name: "client",
        component: () => import("../views/basic-data-user/client/client.vue"),
        meta: { keepAlive: true },
      },
      //基础数据——供应商管理
      {
        path: "/vendor",
        name: "vendor",
        component: () => import("../views/basic-data-user/vendor/vendor.vue"),
        meta: { keepAlive: true },
      },
      // 基础数据——保险公司
      {
        path: "/insurance_company",
        name: "insurance_company",
        component: () =>
          import("../views/basic-data-user/insurance/insurance_company.vue"),
        meta: { keepAlive: true },
      },
      // 销售管理——合同管理
      {
        path: "/contract_add",
        name: "contract_add",
        component: () => import("../views/market/contract/contract_add.vue"),
        meta: { isBack: true, keepAlive: false },
      },
      {
        path: "/contract",
        name: "contract",
        component: () => import("../views/market/contract/contract.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/conapply",
        name: "conapply",
        component: () => import("../views/market/contract/conapply.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/conapply_add",
        name: "conapply_add",
        component: () => import("../views/market/contract/conapply_add.vue"),
        meta: { keepAlive: false },
      },
      // 合同变更
      {
        path: "/contract_change",
        name: "contract_change",
        component: () => import("../views/market/contract/contract_change.vue"),
        meta: { keepAlive: true },
      },
      // 合同打印
      {
        path: "/contract_print",
        name: "contract_print",
        component: () => import("../views/market/contract/contract_print.vue"),
        meta: { keepAlive: false },
      },
      {
        path: "/print",
        name: "print",
        component: () => import("../views/market/contract/print.vue"),
        meta: { keepAlive: false },
      },
      // 销售管理——单据申请
      {
        path: "/changeCar_add",
        name: "changeCar_add",
        component: () => import("../views/market/receipt/changeCar_add.vue"),
        meta: { keepAlive: false },
      },
      {
        path: "/returnCar_add",
        name: "returnCar_add",
        component: () => import("../views/market/receipt/returnCar_add.vue"),
        meta: { keepAlive: false },
      },
      {
        path: "/changeCar",
        name: "changeCar",
        component: () => import("../views/market/receipt/changeCar.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/returnCar",
        name: "returnCar",
        component: () => import("../views/market/receipt/returnCar.vue"),
        meta: { keepAlive: true },
      },
      // 销售管理——提醒查询
      {
        path: "/violation_query",
        name: "violation_query",
        component: () => import("../views/market/remind/violation_query.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/remind_center",
        name: "remind_center",
        component: () => import("../views/market/remind/remind_center.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/remind_compact",
        name: "remind_compact",
        component: () => import("../views/market/remind/remind_compact.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/insuranceWarn",
        name: "insuranceWarn",
        component: () => import("../views/market/remind/insuranceWarn.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/nianjianWarn",
        name: "nianjianWarn",
        component: () => import("../views/market/remind/nianjianWarn.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/maintenanceWarn",
        name: "maintenanceWarn",
        component: () => import("../views/market/remind/maintenanceWarn.vue"),
        meta: { keepAlive: true },
      },
      // 销售管理——车辆保险
      {
        path: "/carInsurance",
        name: "carInsurance",
        component: () => import("../views/market/insurance/carInsurance.vue"),
        meta: { keepAlive: true },
      },
      // 车辆管理——基本资料维护
      {
        path: "/carType",
        name: "carType",
        component: () => import("../views/carMenu/car_msg/carType.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/carmes",
        name: "carmes",
        component: () => import("../views/carMenu/car_msg/carmes.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/carrent",
        name: "carrent",
        component: () => import("../views/carMenu/car_msg/carrent.vue"),
        meta: { keepAlive: true },
      },
      //车辆管理——整车采购
      {
        path: "/vehiclepurchase",
        name: "vehiclepurchase",
        component: () =>
          import("../views/carMenu/car_purchase/vehiclepurchase.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/vehiclepurchaselist",
        name: "vehiclepurchaselist",
        component: () =>
          import("../views/carMenu/car_purchase/vehiclepurchaselist.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/vehiclepurchase_change",
        name: "vehiclepurchase_change",
        component: () =>
          import("../views/carMenu/car_purchase/vehiclepurchase_change.vue"),
        meta: { keepAlive: true },
      },
      // 车辆管理——入出库管理
      {
        path: "/carout",
        name: "carout",
        component: () => import("../views/carMenu/car_warehouse/carout.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/pc_in",
        name: "pc_in",
        component: () => import("../views/carMenu/car_warehouse/pc_in.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/pc_out",
        name: "pc_out",
        component: () => import("../views/carMenu/car_warehouse/pc_out.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/changeCar_in",
        name: "changeCar_in",
        component: () =>
          import("../views/carMenu/car_warehouse/changeCar_in.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/changeCar_out",
        name: "changeCar_out",
        component: () =>
          import("../views/carMenu/car_warehouse/changeCar_out.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/returnCar_in",
        name: "returnCar_in",
        component: () =>
          import("../views/carMenu/car_warehouse/returnCar_in.vue"),
        meta: { keepAlive: true },
      },
      // 车辆运营——车辆监控
      {
        path: "/carPlayback",
        name: "carPlayback",
        component: () => import("../views/operation/operation/carPlayback.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/carPosition",
        name: "carPosition",
        component: () => import("../views/operation/operation/carPosition.vue"),
        meta: { keepAlive: true },
      },
      // 财务管理——应收应付
      {
        path: "/receivable",
        name: "receivable",
        component: () => import("../views/finance/finance/receivable.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/copeWith",
        name: "copeWith",
        component: () => import("../views/finance/finance/copeWith.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——用户资料
      {
        path: "/user",
        name: "user",
        component: () => import("../views/store/user/user.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——加盟管理
      {
        path: "/dealer",
        name: "dealer",
        component: () => import("../views/store/join/dealer.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/service",
        name: "service",
        component: () => import("../views/store/join/service.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——订单管理
      {
        path: "/orderForm",
        name: "orderForm",
        component: () => import("../views/store/order_form/orderForm.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/refund",
        name: "refund",
        component: () => import("../views/store/order_form/refund.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——售后服务
      {
        path: "/examine",
        name: "examine",
        component: () => import("../views/store/after_sale/examine.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/help",
        name: "help",
        component: () => import("../views/store/after_sale/help.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/repair",
        name: "repair",
        component: () => import("../views/store/after_sale/repair.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/maintain",
        name: "maintain",
        component: () => import("../views/store/after_sale/maintain.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——货源管理
      {
        path: "/work",
        name: "work",
        component: () => import("../views/store/work/work.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/work_apply",
        name: "work_apply",
        component: () => import("../views/store/work/work_apply.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——车辆管理
      {
        path: "/used_car",
        name: "used_car",
        component: () => import("../views/store/vehicle/used_car.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/favorite",
        name: "favorite",
        component: () => import("../views/store/vehicle/favorite.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/testDrive",
        name: "testDrive",
        component: () => import("../views/store/vehicle/testDrive.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/violation",
        name: "violation",
        component: () => import("../views/store/vehicle/violation.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——充电桩
      {
        path: "/pile",
        name: "pile",
        component: () => import("../views/store/charging_pile/pile.vue"),
        meta: { keepAlive: true },
      },
      // 商城管理——内容管理
      {
        path: "/message",
        name: "message",
        component: () => import("../views/store/center/message.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/videoView",
        name: "videoView",
        component: () => import("../views/store/center/videoView.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/banner",
        name: "banner",
        component: () => import("../views/store/center/banner.vue"),
        meta: { keepAlive: true },
      },
      // 首页功能
      {
        path: "/signedList",
        name: "signedList",
        component: () => import("../views/signedAll/signedList.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/signed",
        name: "signed",
        component: () => import("../views/signedAll/signed.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/signccList",
        name: "signccList",
        component: () => import("../views/signedAll/signccList.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/messageCenterList",
        name: "messageCenterList",
        component: () => import("../views/signedAll/messageCenterList.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/signnotificationList",
        name: "signnotificationList",
        component: () => import("../views/signedAll/signnotificationList.vue"),
        meta: { keepAlive: true },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
